"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = convertFromBoolean;
function convertFromBoolean(boolean) {
    var value = null;

    if (boolean !== undefined && boolean !== null) {
        if (boolean === true) {
            value = "Yes";
        } else if (boolean === false) {
            value = "No";
        }
    }

    return value;
}